import { z } from 'zod';

/////////////////////////////////////////
// MOBILE PARAMETERS SCHEMA
/////////////////////////////////////////

export const MobileParametersSchema = z.object({
  cityId: z.number().int(),
  mobileBackgroundType: z.string(),
  mobileBackgroundColor: z.string(),
  mobileBackgroundAlpha: z.number().int(),
  mobileBackgroundImage: z.string(),
  mobileIconColor: z.string(),
  mobileIconLabelColor: z.string(),
  mobileIconLabelBackgroundColor: z.string(),
  mobileIconLabelBackgroundAlpha: z.number().int(),
  mobileButtonColor: z.string(),
  mobileButtonTextColor: z.string(),
  mobileButtonBorderColor: z.string(),
  mobileDefaultLocation: z.string(),
  mobileTagline: z.string(),
  mobileLogo: z.string(),
  mobileHiLogo: z.string(),
  mobileLogoBackgroundColor: z.string(),
  mobileLogoBackgroundAlpha: z.number().int(),
  mobileDisclaimer: z.string(),
  mobileMessage: z.string(),
  mobileGPSAccuracy: z.number().int(),
  mobileLockGPSAccuracy: z.number().int(),
  mobileGeocodeMethod: z.number().int(),
  mobileSiteInformation: z.string(),
  mobileKey: z.string(),
  mobileName: z.string(),
  mobileCity: z.string(),
  mobileCounty: z.string(),
  mobileState: z.string(),
  mobileKeyMessage: z.string(),
  mobileInsertMsg: z.string(),
  mobileButton1Name: z.string(),
  mobileButton1URL: z.string(),
  mobileButton2Name: z.string(),
  mobileButton2URL: z.string(),
  mobileButton3Name: z.string(),
  mobileButton3URL: z.string(),
  logoFileId: z.string().nullable(),
  bannerFileId: z.string().nullable(),
})

export type MobileParameters = z.infer<typeof MobileParametersSchema>

export default MobileParametersSchema;
